export default __webpack_public_path__ + "static/contact-img-f6d5c221637e8290e587decf4a08ec41.png";